import { p as proxyCustomElement, H, c as createEvent, h, a as Host } from './index.js';
import { g as getValidityObject, c as checkValidity, r as reportValidity, s as setCustomValidity, a as setInputRef, b as getError, w as watchValue, d as watchError, e as watchWarning } from './p-Cg8AdZPK.js';
import { t as toValue } from './p-CPuegN2k.js';
import { d as defineCustomElement$p } from './p-BbTg3Car.js';
import { d as defineCustomElement$o } from './p-DhNzpZvu.js';
import { d as defineCustomElement$n } from './p-DgmKwGNG.js';
import { d as defineCustomElement$m } from './p-Bu9Snd2Q.js';
import { d as defineCustomElement$l } from './p-B3XAsdJo.js';
import { d as defineCustomElement$k } from './p-C9_XXP_a.js';
import { d as defineCustomElement$j } from './p-BlW2joRF.js';
import { d as defineCustomElement$i } from './p-Dr61d_nc.js';
import { d as defineCustomElement$h } from './p-DmwsS5Ga.js';
import { d as defineCustomElement$g } from './p-BDGM1f6L.js';
import { d as defineCustomElement$f } from './p-DUcqAgyP.js';
import { d as defineCustomElement$e } from './p-DuVPTfuU.js';
import { d as defineCustomElement$d } from './p-ngrwPeVm.js';
import { d as defineCustomElement$c } from './p-BU1hvS3W.js';
import { d as defineCustomElement$b } from './p-DAGYbXiy.js';
import { d as defineCustomElement$a } from './p-D-dZjG8L.js';
import { d as defineCustomElement$9 } from './p-CT2oAZeh.js';
import { d as defineCustomElement$8 } from './p-8RFRaXRI.js';
import { d as defineCustomElement$7 } from './p-DT9iU5If.js';
import { d as defineCustomElement$6 } from './p-DJp0L9dU.js';
import { d as defineCustomElement$5 } from './p-BHesnd1_.js';
import { d as defineCustomElement$4 } from './p-CcMI_rq6.js';
import { d as defineCustomElement$3 } from './p-_P4kPR3l.js';
import { d as defineCustomElement$2 } from './p-CdhcNtiX.js';

const tagsInputCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;container-type:inline-size;display:flex;flex:1;flex-direction:column;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.search-input-container{container-type:inline-size}";

const WuiTagsInput$1 = /*@__PURE__*/ proxyCustomElement(class WuiTagsInput extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.validityChecked = createEvent(this, "validityChecked", 7);
        this.validityReported = createEvent(this, "validityReported", 7);
        //////// FORM FIELD START ////////
        this.value = [];
        this.required = false;
        this.validity = getValidityObject();
        this.validationMessage = '';
        this.customValidation = undefined;
        this.checkValidity = checkValidity(this);
        this.reportValidity = reportValidity(this);
        this.setCustomValidity = setCustomValidity(this);
        this.showValidity = false;
        this.setInputRef = setInputRef(this);
        this.dirty = false;
        this.getError = getError(this);
        this.disabled = false;
        this.label = 'Tags';
        this.options = [];
        this.type = 'single-select';
        this.textAreaValue = '';
        this.setValue = (value) => {
            this.dirty = true;
            this.value = value;
            this.checkValidity();
            this.elm.dispatchEvent(new window.Event('input', { bubbles: true }));
        };
        this.handleSearchChoose = (e) => {
            if (!e.detail.selectedValue) {
                return;
            }
            if (this.type === 'single-select') {
                this.setValue([...(this.value || []), e.detail.selectedValue]);
            }
            if (this.type === 'multiselect') {
                this.setValue(e.detail.selectedValue);
            }
        };
        this.handleTextareaChange = (e) => {
            if (this.type !== 'comma-separated') {
                return;
            }
            this.textAreaValue = e.target.value;
        };
        this.handleAddButtonClick = () => {
            if (this.type !== 'comma-separated') {
                return;
            }
            this.setValue([
                ...(this.value || []),
                ...this.textAreaValue
                    .split(',')
                    .map((s) => s.trim())
                    .filter(Boolean),
            ]);
            this.textAreaValue = '';
        };
        this.handleRemoveTag = (tag) => {
            this.setValue(this.value?.filter((t) => t !== tag) || []);
        };
    }
    _handleValueChange(newValue) {
        watchValue(this, newValue);
    }
    _watchError(...args) {
        watchError(this, ...args);
    }
    _watchWarning(...args) {
        watchWarning(this, ...args);
    }
    render() {
        return (h(Host, { key: '6cd8b42da874a3fd1315d0afce92fd98165c27c7' }, h("wui-form-field", { key: '23bf559082b08e7d1d446eb93166a6c3c2ada7fb', label: this.label }, this.type === 'comma-separated' ? (h("wui-layout", { type: "form-section", container: "lg", orientation: "vertical" }, h("wui-layout", { type: "field-button-group", orientation: "vertical" }, h("wui-textarea", { onInput: this.handleTextareaChange, placeholder: `Enter a list of comma separated ${this.label?.toLowerCase() ?? ''}`, disabled: this.disabled }), h("wui-button", { type: "secondary", label: "Add", onClick: this.handleAddButtonClick, disabled: this.disabled })))) : (h("div", { class: "search-input-container" }, h("wui-layout", { type: "form-section", container: "md", orientation: "vertical" }, h("wui-search-input", { placeholder: "Search", selectedValue: this.type === 'multiselect' ? this.value : undefined, options: this.options, excludeOptions: this.type === 'single-select' ? this.value?.map(toValue) : undefined, onChoose: this.handleSearchChoose, disabled: this.disabled, multiselect: this.type === 'multiselect' }))))), h("wui-layout", { key: 'ca1a435c36049bb7c8f1556fd541a1c13d10b65d', type: "form-section", container: "lg" }, h("wui-form-field", { key: '9ce58a12783e6b1baf28ec4677f97bb101d85633', label: `Added ${(this.label ?? '').toLowerCase()}` }, (this.value?.length ?? 0) > 0 ? (h("wui-tag-list", { type: "contained" }, this.value?.map((tag) => (h("wui-tag", { key: tag, label: tag, action: "remove", onClick: () => this.handleRemoveTag(tag) }))))) : (`No ${(this.label ?? '').toLowerCase()} added yet`)))));
    }
    get elm() { return this; }
    static get watchers() { return {
        "value": ["_handleValueChange"],
        "error": ["_watchError"],
        "warning": ["_watchWarning"]
    }; }
    static get style() { return tagsInputCss; }
}, [257, "wui-tags-input", {
        "value": [1040],
        "required": [8],
        "error": [8],
        "warning": [8],
        "validate": [16],
        "validity": [1040],
        "validationMessage": [1025, "validation-message"],
        "checkValidity": [16, "check-validity"],
        "reportValidity": [16, "report-validity"],
        "setCustomValidity": [16, "set-custom-validity"],
        "formField": [16, "form-field"],
        "disabled": [516],
        "label": [1],
        "options": [16],
        "type": [513],
        "customValidation": [32],
        "showValidity": [32],
        "textAreaValue": [32]
    }, undefined, {
        "value": ["_handleValueChange"],
        "error": ["_watchError"],
        "warning": ["_watchWarning"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-tags-input", "wui-box", "wui-button", "wui-check-input", "wui-check-list-input", "wui-close-button", "wui-divider", "wui-form-field", "wui-icon", "wui-input", "wui-layout", "wui-list", "wui-list-item", "wui-list-item-divider", "wui-list-item-header", "wui-list-item-meta", "wui-loader", "wui-menu-pane", "wui-search-input", "wui-status", "wui-tag", "wui-tag-list", "wui-textarea", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-tags-input":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTagsInput$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$p();
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$o();
            }
            break;
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$n();
            }
            break;
        case "wui-check-list-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$m();
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$l();
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$k();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$j();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$i();
            }
            break;
        case "wui-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$h();
            }
            break;
        case "wui-layout":
            if (!customElements.get(tagName)) {
                defineCustomElement$g();
            }
            break;
        case "wui-list":
            if (!customElements.get(tagName)) {
                defineCustomElement$f();
            }
            break;
        case "wui-list-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "wui-list-item-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "wui-list-item-header":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "wui-list-item-meta":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-menu-pane":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-search-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-tag":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-tag-list":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-textarea":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiTagsInput = WuiTagsInput$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTagsInput, defineCustomElement };
